import React from 'react';
import InvoiceList from './InvoiceList';
import './Projects.css';

export default function Projects({invoices, selectedInvoice, setSelectedInvoice}) {
  return <div className="projects-container"><InvoiceList invoices={invoices} selectedInvoice={selectedInvoice} setSelectedInvoice={setSelectedInvoice}></InvoiceList></div>;
}
